
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgCloseModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.405 15.992l4.286-4.281a1.003 1.003 0 00-.712-1.695 1 1 0 00-.703.278L16 14.584l-4.275-4.29a1 1 0 00-1.633 1.092c.05.121.124.232.217.325l4.286 4.281-4.286 4.282a1.001 1.001 0 101.415 1.417L16 17.399l4.276 4.292a1.001 1.001 0 101.415-1.417l-4.286-4.282z",
    fill: "#000"
  })));
}

export { SvgCloseModal as default };
//# sourceMappingURL=close-modal.svg.js.map
